// extracted by mini-css-extract-plugin
export default {"tile":"Tile_tile__aOBb1","found":"Tile_found__k5vjj","wrapper":"Tile_wrapper__kM0vk"};